module.exports = "<main [ngClass]=\"{'menu-collapsed': isMenuCollapsed}\">\n  <div class=\"additional-bg\"></div>\n  <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main